import { FC } from 'react';
import { Icon } from '@kontentino/ui';
import { faImages } from '@fortawesome/pro-regular-svg-icons/faImages';
import { useTranslation } from 'react-i18next';

const TrashEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-p-8 tw-text-center"
      data-cy="trash-empty-state"
    >
      <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-20">
        <Icon icon={faImages} className="tw-text-primary-100" size="lg" />
      </div>
      <p className="tw-text-sm tw-font-medium tw-text-grayscale-180">
        {t('noPosts', 'No posts')}
      </p>
    </div>
  );
};

export default TrashEmptyState;
